var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex flex-column h-100" }, [
    _c("div", { staticClass: "navbar py-0", class: _vm.theme }, [
      _vm._m(0),
      _c(
        "form",
        { staticClass: "form-inline my-2 my-lg-0 ephemeral-form" },
        [
          !_vm.isEmbedded
            ? [
                _c("label", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary btn-sm mr-sm-2",
                      attrs: { role: "button" }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: ["fas", "upload"],
                          title: _vm.T.wordsUpload,
                          "aria-hidden": "true",
                          "data-zip-upload": ""
                        }
                      })
                    ],
                    1
                  ),
                  _c("input", {
                    staticClass: "d-none",
                    attrs: { type: "file", accept: ".zip" },
                    on: { change: _vm.handleUpload }
                  })
                ]),
                _c("label", [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-secondary btn-sm mr-sm-2",
                      attrs: {
                        role: "button",
                        href: _vm.zipHref,
                        download: _vm.zipDownload,
                        "data-zip-download": ""
                      },
                      on: { click: _vm.handleDownload }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.isDirty
                            ? ["fas", "file-archive"]
                            : ["fas", "download"],
                          title: _vm.isDirty
                            ? _vm.T.zipPrepare
                            : _vm.T.wordsDownload,
                          "aria-hidden": "true"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("label", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary btn-sm mr-2",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.toggleTheme($event)
                        }
                      }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.isDark ? ["fas", "sun"] : ["fas", "moon"],
                          "aria-hidden": "true"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            : _vm._e(),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedLanguage,
                  expression: "selectedLanguage"
                }
              ],
              staticClass: "form-control form-control-sm mr-sm-2",
              attrs: { "data-language-select": "" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.selectedLanguage = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.languages, function(language) {
              return _c(
                "option",
                { key: language, domProps: { value: language } },
                [_vm._v(" " + _vm._s(_vm.getLanguageName(language)) + " ")]
              )
            }),
            0
          ),
          _vm.isRunButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-secondary mr-2 my-sm-0",
                  class: { disabled: !_vm.canExecute },
                  attrs: { disabled: !_vm.canExecute, "data-run-button": "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleRun($event)
                    }
                  }
                },
                [
                  !_vm.canExecute
                    ? _c("omegaup-countdown", {
                        attrs: {
                          "target-time": _vm.nextExecutionTimestamp,
                          "countdown-format":
                            _vm.omegaup.CountdownFormat.EventCountdown
                        },
                        on: {
                          finish: function($event) {
                            _vm.now = Date.now()
                          }
                        }
                      })
                    : [
                        _c("span", [_vm._v(_vm._s(_vm.T.wordsRun))]),
                        _vm.isRunLoading
                          ? _c("span", {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status", "aria-hidden": "true" }
                            })
                          : _vm._e()
                      ]
                ],
                2
              )
            : _vm._e(),
          _vm.isSubmitButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary my-2 my-sm-0",
                  class: { disabled: !_vm.canSubmit },
                  attrs: { disabled: !_vm.canSubmit, "data-submit-button": "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit($event)
                    }
                  }
                },
                [
                  !_vm.canSubmit
                    ? _c("omegaup-countdown", {
                        attrs: {
                          "target-time": _vm.nextSubmissionTimestamp,
                          "countdown-format":
                            _vm.omegaup.CountdownFormat.EventCountdown
                        },
                        on: {
                          finish: function($event) {
                            _vm.now = Date.now()
                          }
                        }
                      })
                    : [
                        _c("span", [_vm._v(_vm._s(_vm.T.wordsSubmit))]),
                        _vm.isSubmitLoading
                          ? _c("span", {
                              staticClass: "spinner-border spinner-border-sm",
                              attrs: { role: "status", "aria-hidden": "true" }
                            })
                          : _vm._e()
                      ]
                ],
                2
              )
            : _vm._e()
        ],
        2
      )
    ]),
    _c("section", { ref: "layout-root", staticClass: "col px-0 flex-grow-1" })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "navbar-brand" }, [
      _vm._v(" omegaUp ephemeral grader "),
      _c("sup", [_vm._v("α")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }